import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type AuthStatus = 'unknown' | 'signedOut' | 'signedIn';

/** The access token lives only in this in-memory store, never in storage (QZ-D29). */
export interface AuthState {
  status: AuthStatus;
  accessToken?: string;
  expiresAt?: number;
}

const initialState: AuthState = { status: 'unknown' };

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signedIn: (
      _state,
      action: PayloadAction<{ accessToken: string; expiresAt: number }>
    ): AuthState => ({ status: 'signedIn', ...action.payload }),
    signedOut: (): AuthState => ({ status: 'signedOut' }),
  },
});

export const { signedIn, signedOut } = authSlice.actions;
export const authReducer = authSlice.reducer;

// Structural, so no import cycle with AppStore.
type WithAuth = { auth: AuthState };

export const selectAuthStatus = (state: WithAuth) => state.auth.status;
export const selectAccessToken = (state: WithAuth) => state.auth.accessToken;
export const selectExpiresAt = (state: WithAuth) => state.auth.expiresAt;
